module.exports = __webpack_public_path__ + "img/wishlist.16d7b2e5.svg";